import { AppBar, Box, Container, Slide, useTheme } from "@mui/material";
import React, { ReactNode } from "react";
import { SxProps } from "@mui/material";
interface IProps {
  top?: ReactNode;
  bottom?: ReactNode;
  justifyContent?: "space-between" | "space-around" | "end" | "start";
}

export default function MobileHeader(props: IProps) {
  const { top, bottom, justifyContent = "space-between" } = props;
  const theme = useTheme();
  return (
    <AppBar position="sticky" sx={sxStyles.appBar}>
      <Container
        maxWidth="lg"
        sx={{
          ...sxStyles.appBarTop,
          justifyContent: justifyContent,
          height: theme.spacing(7.5),
          zIndex: theme.zIndex.appBar,
        }}
      >
        {top}
      </Container>
      <Slide
        direction="down"
        in
        timeout={theme.transitions.duration.enteringScreen}
      >
        <Box sx={sxStyles.appBarBottom}>{bottom}</Box>
      </Slide>
    </AppBar>
  );
}

interface sxStyles {
  [key: string]: SxProps;
}

export const sxStyles: sxStyles = {
  appBar: {
    color: "white.main",
    boxShadow: 1,
    backgroundColor: "initial",
  },
  appBarTop: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    boxShadow: 1,
    backgroundColor: "primary.main",
  },
  appBarBottom: {
    backgroundColor: "white.main",
    color: "black.main",
  },
};
